import {Segment} from 'semantic-ui-react';

function ContactUs() {
  return (
    <Segment>
      <h1>ارتباط با ما</h1>
      <div>
        <span>آدرس کانال تلگرام:</span>&nbsp;
        <a href='https://t.me/medmoshaver'>https://t.me/medmoshaver</a>
      </div>
      <div>
        <span>آدرس اینستاگرام:</span>&nbsp;
        <a href='https://instagram.com/medmoshaver'>https://instagram.com/medmoshaver</a>
      </div>
      <div> آدرس پستی: تهران، بین میدان انقلاب و جمالزاده شمالی، جنب بانک مسکن، پلاک 15، طبقه اول، واحد 2</div>
      <div> شماره تلفن ثابت: 02166439858</div>
      <div>
        <p>ساعات کاری:</p>
        <p>شنبه تا چهارشنبه: ساعت 9 تا 15:30</p>
        <p>پنجشنبه: ساعت 9 تا 13:30</p>
        <p>لطفا قبل از حضور، به صورت تلفنی هماهنگ کنید.</p>
      </div>

    </Segment>
  );
}

export default ContactUs;
